var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"name":"destination"}},[_c('login-widget-modal',{attrs:{"device":_vm.device,"editing":_vm.editing,"model":_vm.site && _vm.site.loginSetting}}),_vm._v(" "),_c('support-setting-widget-modal',{attrs:{"device":_vm.device,"editing":_vm.editing,"model":_vm.site && _vm.site.supportSetting}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }